import { AbstractSubmitStep } from "@component/assets/AbstractLeadForm/Steps/AbstractSubmitStep";
import { 
	faCalendar as fasCalendar,
	faGraduationCap as fasGraduationCap,
	faPlay as fasPlay
 } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatText } from "@ui/format";
import { FormCurrency, FormNumber, FormSelect, ProgressButton } from "bm-ui-kit";
import type { FormApi } from "final-form";
import React from "react";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import { HIGHEST_LEVEL_OF_EDUCATION_OPTIONS } from "../../LeadForm/data";
import type { HighestLevelOfEducation } from "../../LeadForm/types";

export interface StepFields {
	age: number;
	income: number;
	highestLevelOfEducation: HighestLevelOfEducation;
}

const MIN_INCOME = 100_000;
const MAX_INCOME = 2_000_000;

const MIN_AGE = 23;
const MAX_AGE = 55;

export class Step1 extends AbstractSubmitStep<StepFields> {
	protected initValues(): StepFields {
		return {
			age: undefined,
			income: undefined,
			highestLevelOfEducation: undefined,
		};
	}

	protected renderContent(_values: StepFields, form: FormApi<StepFields>): ReactNode {
		const { submitState } = this.props;
		const disabled = this.isDisabled();

		return (
			<>
				<Card.Header>
					<Card.Title className="text-center">Mennyi nyugdíjad lesz?</Card.Title>
				</Card.Header>
				<Card.Body>
					<FormNumber
						label="Életkor"
						placeholder="Add meg az életkorod"
						name="age"
						prepend={<FontAwesomeIcon icon={fasCalendar} />}
						validate={this.validAge}
						disabled={disabled}
						required
					/>
					<FormCurrency
						label="Nettó jövedelem"
						placeholder="Add meg a jövedelmed"
						name="income"
						validate={this.validIncome}
						disabled={disabled}
						required
					/>
					<FormSelect
						label="Legmagasabb iskolai végzettség"
						name="highestLevelOfEducation"
						placeholder="Add meg a végzettséged"
						options={HIGHEST_LEVEL_OF_EDUCATION_OPTIONS}
						prepend={<FontAwesomeIcon icon={fasGraduationCap} />}
						required
					/>
				</Card.Body>
				<Card.Footer className="text-center">
					<ProgressButton
						type="submit"
						icon={<FontAwesomeIcon icon={fasPlay} />}
						state={submitState}
						className={`${!form.getState().valid ? "disabled" : ""} text-uppercase font-weight-bold`}
					>
						Számoljunk
					</ProgressButton>
				</Card.Footer>
			</>
		);
	}

	private validAge(age: number): string {
		if (!age) {
			return `Adja meg az életkorát!`;
		}

		if (age > MAX_AGE || age < MIN_AGE) {
			return `Kérjük, ${MIN_AGE}-${MAX_AGE} év közötti életkort adjon meg!`;
		}
	}

	private validIncome(income: number): string {
		if (!income) {
			return `Adja meg a nettó jövedelmét!`;
		}

		if (income > MAX_INCOME || income < MIN_INCOME) {
			return `Kérjük, ${formatText(MIN_INCOME, "000")} és ${formatText(MAX_INCOME, "000")} Ft közötti nettó jövedelmet adjon meg!`;
		}
	}

	protected getComponentName(): string {
		return "Step1";
	}
}
